import { Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import useAndroidSystemBarInsets from 'app/hooks/useAndroidSystemBarInsets';

export default function useEffectiveBottomInset(fallback = 0) {
  const { bottom } = useSafeAreaInsets();
  const androidSystemBarInsets = useAndroidSystemBarInsets();

  if (Platform.OS !== 'android') {
    return bottom;
  }

  return Math.max(bottom, androidSystemBarInsets.bottom, fallback);
}
